import { getRedeemCode } from 'lib/apis';
import { showTipsDialog } from 'lib/components/TipsDialog';

// 用于记录历史解密过的CDKEY，避免重复请求
export const CDKEY_DECRYPT_MAP: Record<string, { redeemCode: string; redeemNo: string }> = {};

/**
 * 获取CDKEY详情的公共方法
 * @param prizeInfo 奖品信息对象
 * @returns Promise<{ redeemCode: string | null, redeemNo: string | null }>
 */
export async function getCdkeyDetail({ prizeInfo, failTitle = '领取失败' }) {
  const redeemToken = prizeInfo?.redeemToken || prizeInfo?.redeem_token; // TODO 跟国乐确认，统一处理之后是不是都是驼峰了
  let { redeemCode, redeemNo } = prizeInfo || {};
  if (redeemToken) {
    // 先检查缓存中是否已有解密结果
    if (CDKEY_DECRYPT_MAP[redeemToken]) {
      const cachedResult = CDKEY_DECRYPT_MAP[redeemToken];
      return {
        redeemCode: cachedResult.redeemCode,
        redeemNo: cachedResult.redeemNo,
      };
    }

    // 如果缓存中没有，则请求解密
    const decryptRes = await getRedeemCode(redeemToken);
    if (decryptRes?.code !== 0) {
      showTipsDialog({
        title: failTitle,
        content: '请刷新页面后重试，若有疑问请咨询福利鹅微信公众号客服～',
      });
      return { redeemCode: null, redeemNo: null };
    }

    redeemCode = decryptRes.data.redeemCode;
    redeemNo = decryptRes.data.redeemNo;

    // 将解密结果存入缓存
    CDKEY_DECRYPT_MAP[redeemToken] = {
      redeemCode,
      redeemNo,
    };
  }

  return { redeemCode, redeemNo };
}
